import { jsx as _jsx } from "react/jsx-runtime";
import HorizontalMediaCard from './HorizontalMediaCard';
import VerticalMediaCard from './VerticalMediaCard';
const MediaCard = ({ item, size = 'large', horizontal, showPrice, viewAction, registerAction, }) => (horizontal ? (_jsx(HorizontalMediaCard, { item: item, showPrice: showPrice, size: size, viewAction: viewAction, registerAction: registerAction })) : (_jsx(VerticalMediaCard, { item: item, size: size })));
MediaCard.defaultProps = {
    viewAction: undefined,
    registerAction: undefined,
};
export default MediaCard;
//# sourceMappingURL=MediaCard.js.map